import { render } from "./List.vue?vue&type=template&id=27f848d8"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=27f848d8&lang=css"
script.render = render

export default script